<div class="qa-grid mm-page">
  <div class="template-heading">
    <h2>{{_(KEYS.GRID.QUESTIONNAIRE_SHEETS)}}</h2>
    <a *ngIf="canCreateQuestionnaire" class="btn btn-primary" [routerLink]="isNumQuestLimitReached ? null : '/module/questionnaire/editor'"
       [class.disabled]="isNumQuestLimitReached" [attr.aria-disabled]="isNumQuestLimitReached || null"
       [attr.tabindex]="isNumQuestLimitReached ? -1 : null">
      <i class="fa fa-plus" aria-hidden="true"></i> {{_(KEYS.GRID.NEW_QUESTIONNAIRE)}}
    </a>
  </div>

  <div class="card mb-5">
    <div class="card-body">
      <button type="button" class="card-title mm-pane-toggle"
              (click)="isSearchCollapsed = !isSearchCollapsed"
              [attr.aria-expanded]="!isSearchCollapsed" aria-controls="questionnaire-grid-search-fields">
        <span class="mm-pane-toggle-label">
          <i class="fa fa-search" aria-hidden="true"></i>
          <span>{{_(KEYS.GRID.SEARCH)}}</span>
        </span>
        <span class="mm-pane-toggle-icon" aria-hidden="true">
          <i class="fa" [ngClass]="{'fa-chevron-down': isSearchCollapsed, 'fa-chevron-up': !isSearchCollapsed}"></i>
        </span>
      </button>
      <div id="questionnaire-grid-search-fields" class="card-text" [ngbCollapse]="isSearchCollapsed" #qaSearch>
        <div class="search-grid">
          <div class="search-field">
            <label>{{_(KEYS.GRID.TITLE)}}</label>
            <input class="form-control" [(ngModel)]="filter.title"
                   (paste)="onFilterChange()" (change)="onFilterChange()" (keydown)="onFilterChange()">
          </div>

          <div class="search-field">
            <label>{{_(KEYS.GRID.FILTER_GROUPS)}}</label>
            <select class="form-control custom-select" data-edit multiple>
              <ng-container *ngFor="let filtergroup of filtergroupObjects">
                <option [value]="filtergroup.id">
                  {{filtergroup.name[locale]}}
                </option>
              </ng-container>
            </select>
          </div>

          <div class="search-field">
            <label>{{_(KEYS.GRID.AUTHOR)}}</label>
            <input class="form-control" [(ngModel)]="filter.author"
                   (paste)="onFilterChange()" (change)="onFilterChange()" (keydown)="onFilterChange()">
          </div>

          <div class="search-field">
            <label>{{_(KEYS.GRID.STATUS)}}</label>
            <select class="form-control custom-select" [(ngModel)]="filter.status" (change)="onFilterChange()">
              <option value="">...</option>
              <option value="draft">{{_(KEYS.GRID.DRAFT)}}</option>
              <option value="active">{{_(KEYS.GRID.APPROVED)}}</option>
            </select>
          </div>

          <div class="search-field" *ngIf="thiemeLicensed">
            <label>{{_(KEYS.GRID.ORIGIN)}}</label>
            <select class="form-control custom-select" [(ngModel)]="filter.origin" (change)="onFilterChange()">
              <option value="">...</option>
              <option value="mymedax">{{_(KEYS.GRID.ORIGIN_MYMEDAX)}}</option>
              <option value="thieme">{{_(KEYS.GRID.ORIGIN_THIEME)}}</option>
            </select>
          </div>

      </div>
    </div>
  </div>
  </div>

  <div class="card">
    <div class="card-body">
      <div class="card-title mm-pane-header" [class.mm-pane-collapsed]="isGridCollapsed">
        <div class="mm-pane-actions">
          <button class="btn btn-sm btn-success d-inline-block" (click)="onRefresh()">
              <i class="fa fa-refresh"></i>
            </button>
        </div>
        <button type="button" class="mm-pane-toggle"
                (click)="isGridCollapsed = !isGridCollapsed"
                [attr.aria-expanded]="!isGridCollapsed" aria-controls="questionnaire-grid-results">
          <span class="mm-pane-toggle-label"><span>{{_(KEYS.GRID.QUESTIONNAIRES)}}</span></span>
          <span class="mm-pane-toggle-icon" aria-hidden="true">
            <i class="fa" [ngClass]="{'fa-chevron-down': isGridCollapsed, 'fa-chevron-up': !isGridCollapsed}"></i>
          </span>
        </button>
      </div>
      <div id="questionnaire-grid-results" class="card-text" [ngbCollapse]="isGridCollapsed">
        <div class="mm-table-scroll"><table class="table">
          <thead>
          <tr>
            <th class="id-col">{{_(KEYS.GRID.ID)}}</th>
            <th class="qa-cursor-pointer" (click)="onSortChange('meta.title.de_DE')">
              {{_(KEYS.GRID.TITLE)}}
              <i *ngIf="filter.sort === 'meta.title.de_DE' && filter.order === 'asc'" class="fa fa-arrow-up"></i>
              <i *ngIf="filter.sort === 'meta.title.de_DE' && filter.order === 'desc'" class="fa fa-arrow-down"></i>
            </th>
            <th class="td-languages">{{_(KEYS.GRID.LANGUAGES)}}</th>
            <th class="td-filtergroup qa-cursor-pointer" (click)="onSortChange('meta.tags')">
              {{_(KEYS.GRID.FILTER_GROUPS)}}
              <i *ngIf="filter.sort === 'meta.tags' && filter.order === 'asc'" class="fa fa-arrow-up"></i>
              <i *ngIf="filter.sort === 'meta.tags' && filter.order === 'desc'" class="fa fa-arrow-down"></i>
            </th>
            <th class="td-author qa-cursor-pointer" (click)="onSortChange('meta.author')">
              {{_(KEYS.GRID.AUTHOR)}}
              <i *ngIf="filter.sort === 'meta.author' && filter.order === 'asc'" class="fa fa-arrow-up"></i>
              <i *ngIf="filter.sort === 'meta.author' && filter.order === 'desc'" class="fa fa-arrow-down"></i>
            </th>
            <th class="qa-cursor-pointer" (click)="onSortChange('status')">
              {{_(KEYS.GRID.STATUS)}}
              <i *ngIf="filter.sort === 'status' && filter.order === 'asc'" class="fa fa-arrow-up"></i>
              <i *ngIf="filter.sort === 'status' && filter.order === 'desc'" class="fa fa-arrow-down"></i>
            </th>
            <th class="qa-cursor-pointer" (click)="onSortChange('createdAt')">
              {{_(KEYS.GRID.CREATED_AT)}}
              <i *ngIf="filter.sort === 'createdAt' && filter.order === 'asc'" class="fa fa-arrow-up"></i>
              <i *ngIf="filter.sort === 'createdAt' && filter.order === 'desc'" class="fa fa-arrow-down"></i>
            </th>
            <th class="qa-cursor-pointer" (click)="onSortChange('updatedAt')">
              {{_(KEYS.GRID.UPDATED_AT)}}
              <i *ngIf="filter.sort === 'updatedAt' && filter.order === 'asc'" class="fa fa-arrow-up"></i>
              <i *ngIf="filter.sort === 'updatedAt' && filter.order === 'desc'" class="fa fa-arrow-down"></i>
            </th>
            <th class="template-actions-head">{{_(KEYS.GRID.OPTIONS)}}</th>
          </tr>
          </thead>
          <tbody>
            <ng-container *ngFor="let questionnaire of getQuestionnaires(); let pos = index;">
              <tr [ngClass]="{'qa-tr-odd': pos % 2 === 0}">
                <td class="id-col">
                  <span ngbTooltip="{{questionnaire.id}}">{{questionnaire.id | truncate: 5}}</span>
                </td>
                <td>
                  <ngmedax-questionnaire-origin
                    [questionnaire]="questionnaire"
                    [locale]="locale"
                    [editable]="canEditQuestionnaire(questionnaire)"
                    mode="stacked">
                  </ngmedax-questionnaire-origin>
                </td>
                <td class="td-languages">
                  <div class="language-icons d-inline-block">
                    <span class="flags" *ngFor="let langCode of getLangCodes(questionnaire)">
                      <span
                        class="flag-icon flag-icon-{{flagIconCodeMap[langCode]}}"
                        [ngbTooltip]="translateLanguage(languages[langCode])"
                        style="margin-left: 5px;"
                      ></span>
                    </span>
                  </div>
                </td>
                <td class="td-filtergroup">
                  <ng-container *ngIf="questionnaire.meta.tags">
                    <ul>
                      <li *ngFor="let tag of filterTags(questionnaire.meta.tags);">{{tag}}</li>
                    </ul>
                  </ng-container>
                </td>
                <td class="td-author">
                  <span ngbTooltip="{{questionnaire.meta.author}}">
                    {{questionnaire.meta.author | truncate: 20}}
                  </span>
                </td>
                <td>
                  <ng-container *ngIf="questionnaire.status === 'active'; else qaInactive">
                    <span class="template-status approved"><i class="fa fa-check" aria-hidden="true"></i> {{_(KEYS.GRID.APPROVED)}}</span>
                  </ng-container>
                  <ng-template #qaInactive>
                    <span class="template-status draft">{{_(KEYS.GRID.DRAFT)}}</span>
                  </ng-template>
                </td>
                <td>{{questionnaire.createdAt | datex:dateFormat}}</td>
                <td>{{questionnaire.updatedAt | datex:dateFormat}}</td>
                <td>
                  <div class="template-actions">
                    <!-- editing and the preview are the most used actions, so they get quick buttons besides their menu entries -->
                    <button type="button" class="btn btn-sm btn-primary d-inline-block"
                            [routerLink]="canEditQuestionnaire(questionnaire) ? '/module/questionnaire/editor/' + questionnaire.id : null"
                            [disabled]="!canEditQuestionnaire(questionnaire)"
                            title="{{_(KEYS.GRID.CHANGE)}}" [attr.aria-label]="_(KEYS.GRID.CHANGE)">
                      <i class="fa fa-pencil" aria-hidden="true"></i>
                    </button>
                    <app-qa-grid-preview [questionnaire]="questionnaire" #preview></app-qa-grid-preview>
                    <div ngbDropdown container="body" placement="bottom-right" class="d-inline-block">
                      <button type="button" class="btn btn-sm btn-secondary template-options" ngbDropdownToggle
                              [attr.aria-label]="_(KEYS.GRID.OPTIONS)">
                        <i class="fa fa-ellipsis-v" aria-hidden="true"></i>
                      </button>
                      <div ngbDropdownMenu>
                        <button ngbDropdownItem [routerLink]="canEditQuestionnaire(questionnaire) ? '/module/questionnaire/editor/' + questionnaire.id : null"
                                [disabled]="!canEditQuestionnaire(questionnaire)">
                          <i class="fa fa-pencil" aria-hidden="true"></i> {{_(KEYS.GRID.CHANGE)}}
                        </button>
                        <button ngbDropdownItem (click)="preview.openPreview()">
                          <i class="fa fa-eye" aria-hidden="true"></i> {{_(KEYS.GRID.PREVIEW)}}
                        </button>
                        <button ngbDropdownItem (click)="onClone(questionnaire)"
                                [disabled]="!canEditQuestionnaire(questionnaire) || isNumQuestLimitReached">
                          <i class="fa fa-copy" aria-hidden="true"></i> {{_(KEYS.GRID.DUPLICATE)}}
                        </button>
                        <button ngbDropdownItem (click)="onDownload(questionnaire)" [disabled]="!canEditQuestionnaire(questionnaire)">
                          <i class="fa fa-download" aria-hidden="true"></i> {{_(KEYS.GRID.DOWNLOAD)}}
                        </button>
                        <div class="dropdown-divider"></div>
                        <button ngbDropdownItem class="text-danger" (click)="onDelete(questionnaire)"
                                [disabled]="isSimu && filterTags(questionnaire.meta.tags).length === 0">
                          <i class="fa fa-trash" aria-hidden="true"></i> {{_(KEYS.GRID.DELETE)}}
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table></div>

        <div class="btn-toolbar justify-content-between mt-2 mb-2">
          <div class="justify-content-between">
            <div class="input-group">
              <div class="input-group qa-num-per-page">
                <select class="form-control custom-select" [(ngModel)]="displayPerPage" (change)="onPagingChange()">
                  <option value="2">2</option>
                  <option value="5">5</option>
                  <option value="10">10</option>
                  <option value="25">25</option>
                  <option value="50">50</option>
                </select>
                <span class="input-group-addon">{{_(KEYS.GRID.ENTRIES)}}</span>
              </div>
              <label class="btn btn-primary btn-file mb-0 ml-1" [class.disabled]="isProcessing || isNumQuestLimitReached">
                <i class="fa fa-upload"></i> {{_(KEYS.GRID.IMPORT)}}
                <i class="fa fa-spinner fa-pulse fa-fw" *ngIf="isProcessing"></i>
                <form #qaUploadForm>
                  <input
                    *ngIf="!isProcessing && !isNumQuestLimitReached"
                    type="file"
                    (change)="onImportQuestionnaires($event)"
                    accept=".mqt" hidden multiple/>
                </form>
              </label>

              <label *ngIf="!isSimu" class="btn btn-primary btn-file mb-0 ml-1" [class.disabled]="!questionnaires.length" (click)="onExportQuestionnaires()">
                <i class="fa fa-download"></i> {{_(KEYS.GRID.EXPORT_ALL)}}
              </label>
            </div>
          </div>
          <ngb-pagination
            [pageSize]="displayPerPage"
            [maxSize]="9"
            [rotate]="true"
            [(page)]="gridPageNumber"
            [collectionSize]="total"
            (pageChange)="onPagingChange()">
          </ngb-pagination>
        </div>

      </div>
    </div>
  </div>
</div>
